import React, { useState, useEffect } from 'react';
import { Button, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Modal from "../../../components/safe-modal/SafeModal.jsx";
import * as kpi from '../../../services/kpisServices.js'
import Loading from '../../../components/loading/Loading.jsx';
import * as app from '../../../services/appServices.js'
import { TreeSelect } from 'antd';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const FormModal=({toggle,setToggle,dataQuery,setDataQuery})=> {

   const [loading, setLoading] = useState(false);
   const [dataOptions, setDataOptions] = useState([]);
   const [treeData, setTreeData] = useState([]);
   const [value, setValue] = useState(dataQuery?.stId);
   const sessionData=useSelector(state=>state.login);

    useEffect(() => {
        const getCycles = async () => {
            try {
                setLoading(true)
                const response = await app.getStCycles(dataQuery.stId);

                if (response.status === 200) {
                    setDataOptions(response.data);

                    if (response.data.length === 0) {
                        toast.warning('No hay ciclos activos para esta estructura');
                        return;
                    }

                    const activeCycle = response.data.find((item) => item.isActive === true) || response.data[0];
                    setDataQuery({...dataQuery, cycle: activeCycle.number});

                    const responseCmSt = await app.getCommercialStructure(dataQuery.stId, activeCycle.number, sessionData.userData.id);
                    if (responseCmSt.status === 200) {
                        setTreeData(responseCmSt.data);
                    }
                }
            } catch (error) {
                toast.error('No se pudo cargar la estructura comercial');
            }finally{
                setLoading(false);
            }
        }

        if(dataOptions.length===0)
            {
                getCycles();
            }

    }, []);

    const onChange = (value,title) => {
       
        if(value !== undefined)
        {
            setDataQuery({...dataQuery,commercialStSelectedId:value,commercialStSelectedName:title})
            setValue(value);           
        }else{        
            setDataQuery({...dataQuery,commercialStSelectedId:dataQuery.stId,commercialStSelectedName:dataQuery.commercialStructureName})
            setValue(1);
        }
            
    }
    
    return ( 
        <Modal isOpen={toggle} backdrop="static"   centered={true}  size="xl ">
                <ModalHeader toggle={()=>setToggle()}></ModalHeader>
                <ModalBody>
                <Loading toggle={loading} />
                {toggle&&
                    <>
                        <div className="col-md-2">
									<label className="form-label col-form-label ">Ciclo</label>
									</div>
									<div className="col-md-2" >
										<select className="form-select" name="subject" value={dataQuery.cycle} onChange={(e)=>setDataQuery({...dataQuery,cycle:e.target.value})}>
											{dataOptions.map((item)=>(
                                                <option value={item.number} key={item.cycleId}>{item.number}</option>
                                                )
                                            )
                                        }
							    </select>
						    </div>
                            <div className="col-md-2">
									<label className="form-label col-form-label ">Estructura</label>
									</div>
									<div className="col-md-2" >
                                    <TreeSelect
                                        showSearch
                                        style={{
                                            width: '100%',
                                        }}
                                        value={value}
                                        dropdownStyle={{
                                            maxHeight: 400,
                                            overflow: 'auto',
                                        }}
                                        placeholder="Seleccione una estructura"
                                        allowClear= {value?.stId === 1 ? false : true}
                                        onChange={onChange}
                                        treeData={treeData}
                                        // onPopupScroll={onPopupScroll}
                                        />
						    </div>
                       </>
                }
                
                </ModalBody>
                
                <ModalFooter>
                
                <Button color="secondary" onClick={()=>setToggle()}>
                    Cerrar
                </Button>
                </ModalFooter>
        </Modal>
     );
}

export default FormModal;